import { render, staticRenderFns } from "./UsersPassword.vue?vue&type=template&id=5b5eeb0b&"
import script from "./UsersPassword.vue?vue&type=script&lang=js&"
export * from "./UsersPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports